import { ALLOW_ACCESS_CONTEXT_DEMO, hasPermission } from '@common/api/permission';
import { useAppSelector } from '@common/store';
import type User from '@common/types/models/User';
import parseQueryString from '@common/utils/formatting/parseQueryString';
import sessionStorageManager from '@common/utils/storage/sessionStorageManager';
import { SESSION_DEMO_STATE_KEY } from '@common/utils/storage/storageKeys';

export const isDemoState = (user?: User) => {
  if (hasPermission(user, ALLOW_ACCESS_CONTEXT_DEMO)) {
    return true;
  }
  // Also permit switching on/off via URL params
  const queryParams = parseQueryString(window.location.search);
  if (Object.keys(queryParams).includes(SESSION_DEMO_STATE_KEY)) {
    const value = queryParams[SESSION_DEMO_STATE_KEY];
    if (value && value !== '0' && value.toLowerCase() !== 'false') {
      sessionStorageManager.saveItem<boolean>(SESSION_DEMO_STATE_KEY, true);
      return true;
    }
    sessionStorageManager.removeItem(SESSION_DEMO_STATE_KEY);
    return false;
  }
  return !!sessionStorageManager.getItem<boolean>(SESSION_DEMO_STATE_KEY);
};

const useDemoStatus = () => isDemoState(useAppSelector((state) => state.main.user));

export default useDemoStatus;
